import { render, staticRenderFns } from "./MinProducts.vue?vue&type=template&id=66901ff6&scoped=true"
import script from "./MinProducts.vue?vue&type=script&lang=js"
export * from "./MinProducts.vue?vue&type=script&lang=js"
import style0 from "./MinProducts.vue?vue&type=style&index=0&id=66901ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66901ff6",
  null
  
)

export default component.exports